import {
  Component, ElementRef, Input, OnChanges, OnDestroy,
  AfterViewInit, ViewChild, SimpleChanges,
} from '@angular/core';
import SimpleChart from './index.js';
import { ChartOptions } from './chart-options.model';

@Component({
  selector: 'app-simple-chart',
  standalone: true,
  template: `<div #chartContainer style="width:100%; height:100%;"></div>`,
})
export class SimpleChartComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input({ required: true }) options!: ChartOptions;

  @ViewChild('chartContainer', { static: true }) containerRef!: ElementRef<HTMLDivElement>;

  private chart?: any;

  ngAfterViewInit(): void {
    console.log('Creating chart with options:', this.options);
    this.chart = new SimpleChart(this.containerRef.nativeElement, this.options);
    console.log('Chart created:', this.chart);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.chart && !changes['options'].firstChange) {
      this.chart.updateOptions(this.options);
    }
  }

  ngOnDestroy(): void {
    this.chart?.destroy();
  }
}